<template>
    <v-sheet>
        <v-row class="mb-3" :dense="true">
            <v-col>
                <v-chip
                    elevation="9"
                    color="primary"
                    variant="elevated"
                    size="large"
                    class="rounded-lg"
                    style="text-align: center; color: white; margin-right: 10px"
                >
                    Job Entry
                </v-chip>
                <!--                <v-btn class="mr-3 mt-1" color="primary" @click="newJobModal = true">New Job</v-btn>-->
                <!--                <v-divider :vertical="true"></v-divider>-->
                <!--                <v-btn class="mr-3 mt-1" color="blue" @click="refreshBom()">Refresh</v-btn>-->
                <!--                <v-divider :vertical="true"></v-divider>-->
                <!--                <v-btn class="mr-3 mt-1" color="close" @click="clearJob()">Clear</v-btn>-->
                <!--                <v-btn class="mr-3 mt-1" color="red" @click="openDeleteModal()">Delete Job</v-btn>-->

                <v-menu transition="scale-transition" open-on-hover>
                    <template v-slot:activator="{ props }">
                        <v-btn
                            elevation="9"
                            style="margin-left: 20px"
                            color="green"
                            v-bind="props"
                            variant="elevated"
                            prepend-icon="mdi:mdi-arrow-top-right-thick"
                        >
                            Actions
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                            @click="clearJob()"
                            style="cursor: pointer"
                        >
                            <div class="container">
                                <v-icon
                                    size="small"
                                    :style="{
                                        color: 'pink',
                                        marginRight: '2px',
                                    }"
                                    icon="mdi:mdi-eraser"
                                ></v-icon>
                                <v-list-item-title>Clear Job</v-list-item-title>
                            </div>
                        </v-list-item>
                        <v-list-item
                            @click="newJobModal = true"
                            style="cursor: pointer"
                        >
                            <div class="container">
                                <v-icon
                                    size="small"
                                    :style="{
                                        color: 'green',
                                        marginRight: '2px',
                                    }"
                                    icon="mdi:mdi-plus"
                                ></v-icon>
                                <v-list-item-title> New Job</v-list-item-title>
                            </div>
                        </v-list-item>
                        <v-list-item
                            @click="refreshBom()"
                            style="cursor: pointer"
                        >
                            <div class="container">
                                <v-icon
                                    size="small"
                                    :style="{
                                        color: 'blue',
                                        marginRight: '2px',
                                    }"
                                    icon="mdi:mdi-cog-refresh"
                                ></v-icon>
                                <v-list-item-title>Refresh</v-list-item-title>
                            </div>
                        </v-list-item>
                        <v-list-item
                            v-if="can('preview bom')"
                            @click="generateModal = true"
                            style="cursor: pointer"
                        >
                            <div class="container">
                                <v-icon
                                    size="small"
                                    :style="{
                                        color: 'green',
                                        marginRight: '2px',
                                    }"
                                    icon="mdi:mdi-file-excel"
                                ></v-icon>
                                <v-list-item-title
                                    >Generate Summary Sheet</v-list-item-title
                                >
                            </div>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item
                            v-if="can('BOT test pages')"
                            @click="generateQuoteModal = true"
                            style="cursor: pointer"
                        >
                            <div class="container">
                                <v-icon
                                    size="small"
                                    :style="{
                                        color: 'green',
                                        marginRight: '2px',
                                    }"
                                    icon="mdi:mdi-currency-usd"
                                ></v-icon>
                                <v-list-item-title
                                    >Generate Quote Sheet</v-list-item-title
                                >
                            </div>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item
                            @click="openDeleteModal()"
                            style="cursor: pointer"
                        >
                            <div class="container">
                                <v-icon
                                    size="small"
                                    :style="{
                                        color: 'red',
                                        marginRight: '2px',
                                    }"
                                    icon="mdi:mdi-trash-can"
                                ></v-icon>
                                <v-list-item-title
                                    >Delete Job</v-list-item-title
                                >
                            </div>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn
                    :style="{
                        marginLeft: '20px',
                    }"
                    v-if="bom.length"
                    @click="expandAll"
                >
                    <v-icon
                        size="x-large"
                        :style="{
                            color: 'blue',
                        }"
                        icon="mdi:mdi-file-tree"
                    ></v-icon>
                    <v-tooltip
                        v-if="bom.length"
                        activator="parent"
                        location="bottom"
                        >Expand BOM
                    </v-tooltip>
                </v-btn>
            </v-col>
        </v-row>

        <div class="tree">
            <a-input-search
                v-model:value="searchValue"
                style="margin-bottom: 8px"
                placeholder="Search"
            />

            <a-tree
                :tree-data="bom"
                @select="treeSelectHandler"
                show-icon
                :expanded-keys="expandedKeys"
                :auto-expand-parent="autoExpandParent"
                @expand="onExpand"
            >
                <template #title="{ title, type, details }">
                    <div
                        :class="
                            type === 'subcategory'
                                ? 'text-caption font-weight-bold'
                                : 'bom-row'
                        "
                        @contextmenu.prevent="
                            showPartContextMenu($event, title, type, details)
                        "
                    >
                        <v-icon
                            v-if="type !== 'subcategory' && type !== 'job'"
                            :class="setClass(type, details)"
                            :style="{
                                rotate:
                                    type === 'operation' ? '180deg' : '0deg',
                            }"
                            :color="treeIconColor(type)"
                            :icon="treeIcon(type, details)"
                        />

                        <span
                            v-if="
                                title
                                    .toLowerCase()
                                    .indexOf(searchValue.toLowerCase()) > -1
                            "
                        >
                            {{
                                title.substring(
                                    0,
                                    title
                                        .toLowerCase()
                                        .indexOf(searchValue.toLowerCase())
                                )
                            }}
                            <span style="color: #f50">{{
                                title.substring(
                                    title
                                        .toLowerCase()
                                        .indexOf(searchValue.toLowerCase()),
                                    title
                                        .toLowerCase()
                                        .indexOf(searchValue.toLowerCase()) +
                                        searchValue.length
                                )
                            }}</span>
                            {{
                                title.substring(
                                    title
                                        .toLowerCase()
                                        .indexOf(searchValue.toLowerCase()) +
                                        searchValue.length
                                )
                            }}
                        </span>
                        <span v-else>{{ title }}</span>
                    </div>
                </template>
            </a-tree>
            <div class="context-menu" :id="'partContextMenu'">
                <div class="container" @click="deleteContextConfirm">
                    <v-icon
                        :style="{
                            color: 'red',
                            marginRight: '6px',
                        }"
                        icon="mdi:mdi-delete"
                    ></v-icon>
                    <v-list-item-title style="color: red">
                        Delete
                    </v-list-item-title>
                </div>
                <!-- <div class="container" v-if="toDeleteDetails.type === 'assembly' && !toDeleteDetails.details.assemblyStartedBool" @click="openFetchDetailsDialog"> -->
                <div
                    class="container"
                    v-if="toDeleteDetails.type === 'assembly'"
                    @click="openFetchDetailsDialog"
                >
                    <v-icon
                        :style="{
                            color: 'blue',
                            marginRight: '6px',
                        }"
                        icon="mdi:mdi-refresh"
                    ></v-icon>
                    <v-list-item-title style="color: blue">
                        Re-Fetch Details
                    </v-list-item-title>
                </div>
                <!-- <div class="container" v-else-if="toDeleteDetails.type === 'assembly' && toDeleteDetails.details.assemblyStartedBool">
                    <v-icon
                        :style="{
                            color: 'gray',
                            marginRight: '6px',
                        }"
                        icon="mdi:mdi-refresh"
                    ></v-icon>
                    <v-list-item-title style="color: gray">
                        Re-Fetch Details
                    </v-list-item-title>
                    <v-tooltip activator="parent" location="bottom">
                        {{ toDeleteDetails.details.assemblyStartedMessage }}
                    </v-tooltip>
                </div> -->
            </div>
        </div>
        <div class="overlay" @click="closeContextMenu" id="overlay"></div>
    </v-sheet>

    <v-dialog v-model="deleteModal" max-width="700">
        <v-card>
            <v-card-title class="headline">
                <div style="text-align: center">
                    Are you sure you want to delete this job ({{ job.JobNum }})?
                </div>
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="deleteModal = false"
                    >Cancel
                </v-btn>
                <v-btn color="red" text @click="deleteConfirm">Delete </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="refreshAssemblyModal" max-width="700">
        <v-card>
            <v-card-title class="headline">
                <div
                    style="
                        text-align: center;
                        white-space: inherit;
                        padding: 10px;
                        overflow-x: hidden;
                    "
                >
                    By refetching this assembly this will change everything
                    <br />
                    under this assembly to the current version.
                    <br />
                    (even changes you may have made on this
                    <br />
                    page will get set to the current version).
                    <br />
                    Are you sure you want to refetch?
                </div>
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="refreshAssemblyModal = false"
                    >Cancel
                </v-btn>
                <v-btn color="red" text @click="refetchConfirm">Refetch </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="jobReleasedModal" max-width="700">
        <v-card>
            <v-card-title class="headline">
                <div style="text-align: center">
                    You can not delete a Job that has been released
                </div>
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="jobReleasedModal = false"
                    >Cancel
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="jobIssuedModal" max-width="700">
        <v-card>
            <v-card-title class="headline">
                <div style="text-align: center">
                    You can not delete a Job that has had quantity issued to a
                    material
                </div>
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="jobIssuedModal = false"
                    >Cancel
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="jobStartedBool" max-width="700">
        <v-card>
            <v-card-title class="headline">
                <div style="text-align: center; white-space: wrap !important">
                    {{ jobStartedMessage }}
                </div>
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="jobStartedBool = false"
                    >Cancel
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="generateModal" max-width="520">
        <v-card class="pa-4 rounded-xl">
            <v-card-title class="text-h6 text-center">
                Generate Summary Sheet
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="summaryProjectNum"
                            label="Project Number"
                            variant="outlined"
                            density="comfortable"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-select
                            variant="outlined"
                            label="Ship Via"
                            v-model="shipViaCode"
                            :items="shipViaArray"
                            item-value="ShipViaCode"
                            item-title="Description"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" class="d-flex justify-center align-center">
                        <v-checkbox
                            color="primary"
                            label="B2D?"
                            v-model="b2d"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="graphicsDueDate"
                            label="Graphics Due Date"
                            variant="outlined"
                            type="date"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="installedGraphicsDueDate"
                            label="Installed Graphics Due Date"
                            variant="outlined"
                            type="date"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-file-input
                            v-model="summaryFile"
                            label="Upload PDF"
                            accept=".pdf"
                            variant="outlined"
                            density="comfortable"
                            prepend-icon="mdi:mdi-file-pdf-box"
                            multiple
                        />

                        <div class="text-caption text-medium-emphasis mt-2">
                            The system will extract BOM data and generate an
                            Excel summary sheet.
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="justify-space-between">
                <v-btn color="close" @click="generateModal = false">
                    Close
                </v-btn>

                <v-btn
                    color="primary"
                    :loading="summaryLoading"
                    :disabled="!summaryFile || summaryLoading"
                    @click="generateSummarySheet"
                >
                    Generate
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="generateQuoteModal" max-width="800">
        <QuoteModal
            @close="generateQuoteModal = false"
        />
    </v-dialog>
    <v-snackbar
        v-model="summarySnackbar"
        :color="summaryError ? 'red' : 'green'"
        timeout="4000"
    >
        {{ summaryMessage }}
    </v-snackbar>
</template>
<script>
import { useJobEntryStore } from "../../../stores/ProjectManagement/JobEntry";
import { mapWritableState } from "pinia";
import "ant-design-vue/dist/antd.css";
import axios from "axios";
import { defineAsyncComponent } from "vue";
const QuoteModal = defineAsyncComponent(() =>
    import("./Modals/QuoteModal.vue")
);

export default {
    components: {QuoteModal},
    emits: ["tree-item-selected"],
    computed: {
        ...mapWritableState(useJobEntryStore, {
            newJobModal: "newJobModal",
            bom: "bom",
            job: "job",
            setJob: "setJob",
            clearJob: "clearJob",
            fetchJobData: "fetchJobData",
            overlay: "overlay",
            setErrorMessage: "setErrorMessage",
            selectedOperations: "selectedOperations",
            selectedParts: "selectedParts",
            toDeleteDetails: "toDeleteDetails",
        }),
    },
    data() {
        return {
            deleteModal: false,
            scheduleJobModal: false,
            jobReleasedModal: false,
            jobIssuedModal: false,
            jobStartedBool: false,
            jobStartedMessage: false,
            refreshAssemblyModal: false,
            generateModal: false,
            generateQuoteModal: false,
            graphicsDueDate: null,
            installedGraphicsDueDate: null,
            summaryFile: [],
            summaryProjectNum: null,
            summaryLoading: false,
            summarySnackbar: false,
            summaryMessage: "",
            summaryError: false,
            searchValue: "",
            x: 1,
            y: 2,
            z: 3,
            expandedKeys: [],
            autoExpandParent: true,
            shipViaArray: [],
            b2d: false,
            shipViaCode: null,
        };
    },
    watch: {
        searchValue(value) {
            const expanded = [];
            this.searchTree(this.bom, value, expanded);

            this.expandedKeys = expanded;
            this.autoExpandParent = true;
        },
    },
    async mounted() {
        try {
            await axios
                .get(route("legacy-api.po-shipVia", { PM: true }))
                .then((res) => {
                    this.shipViaArray = res.data;
                });
        } catch (err) {
            console.log(err);
        }
    },
    methods: {
        showPartContextMenu(event, title, type, details) {
            if (
                parseInt(this.job.JobClosed) === 0 &&
                ((type === "assembly" && parseInt(details.AssemblySeq) !== 0) ||
                    type === "operation" ||
                    type === "material")
            ) {
                this.toDeleteDetails = {
                    title: title,
                    type: type,
                    details: details,
                };

                let partContextMenu =
                    document.querySelector("#partContextMenu");
                // The overlay takes up the entre screen with an @onclick attribute so when you click outside the context menu the menu will disappear
                let overlay = document.querySelector("#overlay");
                // The next two lines get the coordinates of the part clicked
                let menuX = event.clientX;
                let menuY = event.clientY;
                // The next few lines deal with displaying the context menu, putting it in the right spot and highlighting the part clicked on
                partContextMenu.style.display = "block";
                overlay.style.display = "block";
                partContextMenu.style.left = menuX + "px";
                partContextMenu.style.top = menuY + "px";
            }
        },
        deleteContextConfirm() {
            this.overlay = true;
            let params = {};
            if (this.toDeleteDetails.type === "assembly") {
                params = {
                    Type: "assembly",
                    JobNum: this.toDeleteDetails.details.JobNum,
                    AssemblySeq: this.toDeleteDetails.details.AssemblySeq,
                    PartNum: this.toDeleteDetails.details.PartNum,
                    SysRowID: this.job.SysRowID ?? null,
                    AssemblyId: this.toDeleteDetails.details.id ?? null,
                };
            } else if (this.toDeleteDetails.type === "operation") {
                params = {
                    Type: "operation",
                    JobNum: this.toDeleteDetails.details.JobNum,
                    AssemblySeq: this.toDeleteDetails.details.AssemblySeq,
                    OpCode: this.toDeleteDetails.details.OpCode,
                    OprSeq: this.toDeleteDetails.details.OprSeq,
                    SysRowID: this.job.SysRowID ?? null,
                    OperationId: this.toDeleteDetails.details.id ?? null,
                };
            } else if (this.toDeleteDetails.type === "material") {
                params = {
                    Type: "material",
                    JobNum: this.toDeleteDetails.details.JobNum,
                    AssemblySeq: this.toDeleteDetails.details.AssemblySeq,
                    MtlSeq: this.toDeleteDetails.details.MtlSeq,
                    Description: this.toDeleteDetails.details.Description,
                    SysRowID: this.job.SysRowID ?? null,
                    MaterialId: this.toDeleteDetails.details.id ?? null,
                    PartNum: this.toDeleteDetails.details.PartNum,
                };
            }

            try {
                axios
                    .post(route("api.epicor.jobs.bom.remove", params))
                    .then((res) => {
                        if (res.data.Status === 0) {
                            alert(res.data.Message);
                        } else {
                            this.setJob(res.data.data);
                        }
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            } catch (err) {
                console.log(err);
            }
            this.closeContextMenu();
        },
        openFetchDetailsDialog() {
            this.refreshAssemblyModal = true;
        },
        treeIcon(type, details) {
            // NO ICON FOR THE FOLLOWING TREE TITLES
            const nonIconTitles = [
                "subassemblies",
                "operations",
                "materials",
                "resources",
            ];
            if (type === "subcategory") {
                return "";
            }

            if (type === "assembly") {
                return "fas fa-cubes";
            } else if (
                type === "operation" &&
                Number(details.SubContract) === 0
            ) {
                return "fa-solid fa-rotate-left";
            } else if (
                type === "operation" &&
                Number(details.SubContract) === 1
            ) {
                return "fas fa-exchange-alt";
            } else if (type === "material") {
                return "mdi:mdi-tag";
            } else {
                return "";
            }
        },
        treeIconColor(type) {
            switch (type) {
                case "assembly":
                    return "#1459cf";
                case "operation":
                    return "#7c9ffc";
                case "material":
                    return "#ffdd2b";
                default:
                    return "";
            }
        },
        setClass(type, details) {
            if (
                (details && details.PullAsAsm === 1) ||
                details.PullAsAsmParent == 1
            ) {
                return "pull-as-asm";
            }
            if (type === "operation" && Number(details.SubContract) === 1) {
                return "subcontract-rotate mr-1";
            } else {
                return "mr-1";
            }
        },
        treeSelectHandler(selectedKeys, event) {
            this.$emit("tree-item-selected", event);
        },
        async refreshBom() {
            this.overlay = true;
            let JobNum = this.job.JobNum;
            let job = await this.fetchJobData(JobNum);
            this.setJob(job);
            this.overlay = false;
        },
        async rebuildBom() {
            await axios
                .post(
                    route("api.epicor.job-refetch", {
                        JobNum: this.job.JobNum,
                    })
                )
                .then((res) => {
                    if (res.data.Status == 0) {
                        this.setErrorMessage(res.data.Epicor.Message);
                    } else {
                        this.clearJob();
                        this.job.JobNum = null;
                    }
                });
        },
        openDeleteModal() {
            if (
                this.job.PartNum &&
                parseInt(this.job.JobReleased) === 0 &&
                !this.job.jobStartedBool &&
                !this.job.IssuedQtyBool
            ) {
                this.deleteModal = true;
            } else if (parseInt(this.job.JobReleased) === 1) {
                this.jobReleasedModal = true;
            } else if (this.job.IssuedQtyBool) {
                this.jobIssuedModal = true;
            } else if (this.job.jobStartedBool) {
                this.jobStartedBool = true;
                this.jobStartedMessage = this.job.jobStartedMessage;
            }
        },
        schedule() {
            if (this.job.JobReleased) {
                this.scheduleJobModal = true;
            }
        },
        async deleteConfirm() {
            this.overlay = true;
            this.deleteModal = false;
            try {
                await axios
                    .post(
                        route("legacy-api.project-pmDeleteJob", {
                            JobNum: this.job.JobNum,
                        })
                    )
                    .then((res) => {
                        if (res.data.Status == 0) {
                            this.setErrorMessage(res.data.Epicor.Message);
                        } else {
                            this.clearJob();
                            this.job.JobNum = null;
                        }
                    });
            } catch (err) {
                console.log(err);
            }
            this.overlay = false;
        },
        async refetchConfirm() {
            this.overlay = true;
            this.refreshAssemblyModal = false;
            try {
                await axios
                    .post(
                        route("api.epicor.asmbly-refresh", {
                            JobNum: this.job.JobNum,
                            AssemblySeq:
                                this.toDeleteDetails.details.AssemblySeq,
                            PartNum: this.toDeleteDetails.details.PartNum,
                        })
                    )
                    .then((res) => {
                        if (res.data.Status === 0) {
                            this.setErrorMessage(res.data.Message);
                            this.overlay = false;
                        } else {
                            this.refreshBom();
                        }
                        this.closeContextMenu();
                    });
            } catch (err) {
                console.log(err);
            }
        },
        closeContextMenu() {
            // This function is built in a way that will hide any context menu that is open this the overlay component is reused for all of them
            let contextMenus = document.querySelectorAll(".context-menu");
            let overlay = document.querySelector("#overlay");
            contextMenus.forEach((el) => {
                el.style.display = "none";
            });
            if (overlay) {
                overlay.style.display = "none";
            }
            this.toDeleteDetails = {};
        },

        searchTree(nodes, value, expanded) {
            for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];

                // Check if the title or PartNum contains the search value
                const matchesTitle =
                    node.title &&
                    node.title.toLowerCase().includes(value.toLowerCase());
                const matchesPartNum =
                    node.details &&
                    node.details.PartNum &&
                    node.details.PartNum.toLowerCase().includes(
                        value.toLowerCase()
                    );

                if (matchesTitle || matchesPartNum) {
                    // Add parent key to expandedKeys
                    const parentKey = this.getParentKey(node.key, this.bom);
                    if (parentKey && !expanded.includes(parentKey)) {
                        expanded.push(parentKey);
                    }
                }

                // Traverse children recursively
                if (node.children && node.children.length > 0) {
                    this.searchTree(node.children, value, expanded);
                }
            }
        },
        getParentKey(key, tree) {
            let parentKey;
            for (let i = 0; i < tree.length; i++) {
                const node = tree[i];
                if (node.children) {
                    if (node.children.some((item) => item.key === key)) {
                        parentKey = node.key;
                    } else if (this.getParentKey(key, node.children)) {
                        parentKey = this.getParentKey(key, node.children);
                    }
                }
            }
            return parentKey;
        },
        getAllKeys(treeData) {
            let keys = [];
            treeData.forEach((node) => {
                keys.push(node.key);
                if (node.children && node.children.length) {
                    keys = keys.concat(this.getAllKeys(node.children));
                }
            });
            return keys;
        },
        async generateSummarySheet() {
            if (!this.summaryFile) {
                this.summaryMessage = "Please select a PDF file.";
                this.summaryError = true;
                this.summarySnackbar = true;
                return;
            }

            // if (!this.summaryProjectNum) {
            //     this.summaryMessage = "Please enter a project number.";
            //     this.summaryError = true;
            //     this.summarySnackbar = true;
            //     return;
            // }

            if (!this.shipViaCode) {
                this.summaryMessage = "Please enter a ship via code.";
                this.summaryError = true;
                this.summarySnackbar = true;
                return;
            }

            this.summaryLoading = true;
            this.overlay = true;

            try {
                const formData = new FormData();
                this.summaryFile.forEach((f) => {
                    formData.append("files[]", f);
                });
                formData.append("project_num", this.summaryProjectNum);
                formData.append("shipViaCode", this.shipViaCode);
                formData.append("graphicsDueDate", this.graphicsDueDate);
                formData.append("installedGraphicsDueDate", this.installedGraphicsDueDate);
                formData.append("b2d", this.b2d);
                formData.append("model_name", "summary_sheet");

                const res = await axios.post(
                    route("chat-callAIModel"),
                    formData
                );

                this.summaryMessage = res.data.message;
                this.summaryError = false;
                this.summarySnackbar = true;
            } catch (err) {
                const text = await err.response.data.text();
                const json = JSON.parse(text);

                this.summaryMessage = json.message;
                this.summaryError = true;
                this.summarySnackbar = true;
            }

            this.summaryLoading = false;
            this.overlay = false;
            this.generateModal = false;
            this.summaryFile = [];
            this.summaryProjectNum = null;
        },
        expandAll() {
            this.expandedKeys = this.getAllKeys(this.bom);
        },
        onExpand(keys) {
            this.expandedKeys = keys;
            this.autoExpandParent = false;
        },
    },
};
</script>
<style scoped>
.tree {
    overflow-y: auto;
    overflow-x: hidden;
    height: 78vh;
}
.context-menu {
    position: fixed;
    display: none;
    /* position: absolute; */
    background: white;
    border: 1px solid #ccc;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    min-width: 150px;
    z-index: 49;
}
.context-menu div {
    padding: 10px;
    cursor: pointer;
}
.context-menu div:hover {
    background-color: #f0f0f0;
}
.container {
    display: flex;
    align-items: center;
    height: 40px;
}
.overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    /* z-index: 49; */
}
.overlay::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 48;
}
.overlay:hover {
    cursor: pointer;
}
.bom-row {
    color: black;
    white-space: nowrap;
}
.bom-row:hover {
    white-space: inherit;
}
.subcontract-rotate {
    transform: rotate(-90deg);
}
.pull-as-asm {
    color: #e1bee7 !important; /* or whatever color */
    font-weight: 600;
}
</style>
